import axios from "axios";

export default function resetPassword({ oldPassword, newPassword }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/reset-password`, {
      old_password: oldPassword, new_password: newPassword,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
